import React from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import { renderComponent } from '@trello/component-wrapper';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { PremiumFeature } from '@trello/product-features';
import ReactDOM from '@trello/react-dom-wrapper';
import { navigate } from '@trello/router/navigate';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { getBoardUrl } from 'app/scripts/controller/urls';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { WindowSize } from 'app/scripts/lib/window-size';
import { BoardCleanUpView } from 'app/scripts/views/board/BoardCleanUpView';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { SingleBoardCalendarView } from 'app/src/components/BoardCalendarView';
import { BoardHeader } from 'app/src/components/BoardHeader';
import { AutomaticReports } from 'app/src/components/Butler';
import { filteredCardsCountState } from 'app/src/components/FilterPopover/filteredCardsCountState';
import { SingleBoardTableView } from 'app/src/components/TableView/SingleBoardTableView';
import { TimelineViewWrapper } from 'app/src/components/TimelineViewWrapper';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderReactBoardHeader = function (this: any) {
  const headerTarget = this.el.querySelector('.js-board-header');

  if (!headerTarget) {
    return;
  }

  const sidebarVisible = this.model.viewState.get('showSidebar');
  const showSidebar = () => this.model.viewState.setShowSidebar(true);
  renderComponent(
    <BoardHeader
      boardId={this.model.id}
      legacyBoardModel={this.model}
      sidebarVisible={sidebarVisible}
      // eslint-disable-next-line react/jsx-no-bind
      showSidebar={showSidebar}
    />,
    headerTarget,
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeReactBoardHeader = function (this: any) {
  if ($('.js-board-header', this.$el).length) {
    return ReactDOM.unmountComponentAtNode(
      this.el.querySelector('.js-board-header'),
    );
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const clearFilters = function (this: any, e: any) {
  stopPropagationAndPreventDefault(e);
  Analytics.sendClickedButtonEvent({
    buttonName: 'clearBoardFilterButton',
    source: 'boardScreen',
    containers: {
      board: {
        id: this.model.id,
      },
      organization: {
        id: this.model.getOrganization()?.id,
      },
      enterprise: {
        id: this.model.getEnterprise()?.id,
      },
    },
  });

  this.model.filter.clear();
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showCleanUp = function (this: any, e: any) {
  stopPropagationAndPreventDefault(e);

  const view = new BoardCleanUpView({
    model: this.model,
  });
  Dialog.show({
    view,
    maxWidth: 800,
    hide() {
      return view.abort();
    },
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showTimeline = function (this: any) {
  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  if (hasViewsFeature) {
    $('#board', this.$el).addClass('hide');
    const container = this.el.querySelector('.js-board-view-container');
    renderComponent(
      <TimelineViewWrapper
        idBoard={this.model.id}
        /* eslint-disable-next-line react/jsx-no-bind, @typescript-eslint/no-explicit-any */
        navigateToCard={(id: any, params: any) => {
          // @ts-expect-error
          Controller.showCardDetail(ModelCache.get('Card', id), params);
        }}
      />,
      container,
    );
  } else {
    const boardUrl = getBoardUrl(this.model.id);
    navigate(boardUrl, { trigger: true });
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showCalendarView = function (this: any) {
  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  const canShowCalendarView = hasViewsFeature;

  if (canShowCalendarView) {
    $('#board', this.$el).addClass('hide');
    const container = this.el.querySelector('.js-board-view-container');
    renderComponent(
      <SingleBoardCalendarView
        idBoard={this.model.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToCard={(id) => {
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          Controller.showCardDetail(ModelCache.get('Card', id));
        }}
      />,
      container,
    );
  } else {
    const boardUrl = getBoardUrl(this.model.id);
    // @ts-expect-error TS(2345): Argument of type '{ trigger: true; shouldTrack: bo... Remove this comment to see the full error message
    navigate(boardUrl, { trigger: true, shouldTrack: false });
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showTable = function (this: any) {
  const hasViewsFeature = this.model.isFeatureEnabled(PremiumFeature.Views);

  if (hasViewsFeature) {
    $('#board', this.$el).addClass('hide');

    const container = this.el.querySelector('.js-board-view-container');
    renderComponent(
      <SingleBoardTableView
        idBoard={this.model.id}
        // eslint-disable-next-line react/jsx-no-bind
        navigateToCard={(id) => {
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          Controller.showCardDetail(ModelCache.get('Card', id));
        }}
      />,
      container,
    );
  } else {
    const boardUrl = getBoardUrl(this.model.id);
    navigate(boardUrl, { trigger: true });
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const closeSingleBoardView = function (this: any) {
  const viewContainer = this.el.querySelector('.js-board-view-container');
  if (viewContainer) {
    ReactDOM.unmountComponentAtNode(viewContainer);
  }
  $('#board', this.$el).removeClass('hide');
  $('.js-list-name-input', this.$el).trigger('autosize.resize', false);
};

export const navigateToAutomaticReports = function (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  this: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reportType: any,
) {
  const automaticReportView = getBoardUrl(
    this.model.id,
    `butler/reports/${reportType}`,
  );

  navigate(automaticReportView, { trigger: true });

  // Close the sidebar menu for window sizes that aren't extra large.

  // @ts-expect-error TS(2339): Property 'fExtraLarge' does not exist on type '{ c... Remove this comment to see the full error message
  if (!WindowSize.fExtraLarge) {
    this.sidebarView.hideSidebar();
  }
};

// This is actually pretty generic and just closes any overlays;
// if it ever needs reuse, feel free to rename it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const closeAutomaticReports = function (this: any, idBoard: any) {
  const boardUrl = getBoardUrl(idBoard || this.model.id);
  navigate(boardUrl, { trigger: true });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showAutomaticReports = function (this: any, reportType: any) {
  const idBoard = this.model.id;
  const container = this.el.querySelector('.js-board-view-container');
  $('#board', this.$el).addClass('hide');

  renderComponent(
    <AutomaticReports
      reportType={reportType}
      idBoard={idBoard}
      idOrganization={this.model.get('idOrganization')}
      boardName={this.model.get('name')}
      // eslint-disable-next-line react/jsx-no-bind
      closeView={() => closeAutomaticReports(idBoard)}
    />,
    container,
  );
  Analytics.sendViewedComponentEvent({
    componentType: 'overlay',
    // @ts-expect-error TS(2322): Type '"butlerReportBuilderOverlay"' is not assigna... Remove this comment to see the full error message
    componentName: 'butlerReportBuilderOverlay',
    source: 'butlerReportBuilderOverlay',
    attributes: {
      reportType,
    },
  });
};

// There are many things that could cause the filter count to change
const watchedEvents = [
  // We could learn about a new card that matches the filter
  'add:Card',
  // A card that matched the filter may have been deleted
  'remove:Card',
  // A card may change so that it is no a match (or isn't one anymore)
  'change:Card',
  // We could learn about a new list that has matches in it (e.g. a list may have been moved to this board)
  'add:List',
  // A list that had matches in it could have been moved off of the board
  'remove:List',
  // A list with matches could have been closed or re-opened
  'change:List',
].join(' ');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initializeFilterCountMonitoring = function (this: any) {
  let isMonitoring = false;
  const updateCount = this.frameDebounce(() => {
    const boardCardCount = this.model.filter.isFiltering()
      ? this.model
          .openCards()
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .filter((card: any) => this.model.filter.satisfiesFilter(card)).length
      : 0;

    // Keep the filtered cards count for the board in sync with a shared state,
    // to avoid an unnecessary API call for SBVs. If this gets migrated to GraphQL
    // and we have the data in cache, we can eventually deprecate this.
    if (boardCardCount !== filteredCardsCountState.value.count) {
      filteredCardsCountState.setValue({ count: boardCardCount });
    }
  });

  const updateMonitoring = () => {
    const isFiltering = this.model.filter.isFiltering();
    if (isFiltering) {
      if (!isMonitoring) {
        isMonitoring = true;
        // Listen for all of the watched events that happen in the ModelCache, including
        // (possibly) events related to other boards.  Some of the events won't affect the
        // count (e.g. if a card changes position, or we got an update about a card on another
        // board) but counting the cards isn't too expensive if we're debouncing it
        this.listenTo(this.modelCache, watchedEvents, updateCount);
      }
      // The filter changed, so the count may be different
      updateCount.call(this);
    } else if (!isFiltering && isMonitoring) {
      isMonitoring = false;
      this.stopListening(this.modelCache, watchedEvents, updateCount);
    }
  };

  // Only monitor the model cache if we're currently filtering
  this.listenTo(this.model.filter, 'change', updateMonitoring);
  updateMonitoring();
};
